import React from "react";
import { Helmet } from "react-helmet-async";
import "./Roadmap.css";
import banner from "../assets/lb/mainbanner.jpg";

function Roadmap() {
  const phases = [
    {
      title: "BASIC AI - “LIA” LAUNCH",
      details: [
        "Lia is the core of Lia Lab, an AI assistant offering fundamental utilities for users to explore the ecosystem. Key features include:",
        {
          title: "Platform Navigation Assistance : ",
          description: "Lia helps users seamlessly navigate Lia Lab and its utilities."
        },
        {
          title: "NFT Market Insights : ",
          description: "Real-time data and trends to support informed marketplace decisions."
        },
        {
          title: "Personalized Recommendations : ",
          description: "Tailored suggestions for managing portfolios, buying, selling, and trading NFTs."
        },
        "With Lia now active, Lia Lab begins its journey with AI-powered support."
      ]
    },
    {
      title: "PHASE 2: NFT COLLECTION - “LIA” COLLECTION LAUNCH",
      details: [
        "The next step is launching the Lia NFT collection, introducing the heart of Lia Lab’s ecosystem.",
        {
          title: "NFT Minting : ",
          description: "Users can mint exclusive Lia NFTs, unlocking unique utilities and opportunities."
        },
        {
          title: "Early Adopter Rewards : ",
          description: "Initial holders receive exclusive perks, fostering a committed community."
        },
        {
          title: "DAO Introduction : ",
          description: "NFT holders gain voting rights and participate in shaping the platform’s future."
        }
      ]
    },
    {
      title: "PHASE 3: ADVANCED AI FOR TRADING & ANALYSIS",
      details: [
        "An enhanced version of Lia will be launched, focusing on advanced market and trading functionalities",
        {
          title: "Advanced Market Analysis : ",
          description: "Lia uses AI to predict trends, offer insights, and enhance trading strategies."
        },
        {
          title: "Real-Time Notifications : ",
          description: "Alerts for profitable opportunities and market changes."
        },
        {
          title: "Enhanced Personalized Trading Strategies : ",
          description: "Data-driven, actionable insights for user-specific trading."
        }
      ]
    },
    {
      title: "PHASE 4: DECENTRALIZED AUTONOMOUS ORGANIZATION (DAO)",
      details: [
        "Lia Lab will implement full DAO governance, empowering the community",
        {
          title: "Voting Rights : ",
          description: "Lia NFT holders influence decisions on platform development and features."
        },
        {
          title: "Proposal System : ",
          description: "Community-driven proposals for transparent and collaborative growth."
        },
        {
          title: "Community Engagement : ",
          description: "Town halls and events for active participation and collaboration."
        }
      ]
    },
    {
      title: "PHASE 5: STAKING AND REWARDS SYSTEM",
      details: [
        "A staking system will be introduced for Lia NFT holders",
        {
          title: "NFT Staking : ",
          description: "Earn rewards while contributing to the ecosystem’s growth."
        },
        {
          title: "Reward Multiplication : ",
          description: "Compounding incentives for long-term stakers."
        },
        {
          title: "Governance Rewards : ",
          description: "Active participants in governance receive exclusive tokens."
        }
      ]
    },
    {
      title: "PHASE 6: NFT LEASING SYSTEM",
      details: [
        "Monetize NFTs passively through leasing",
        {
          title: "Leasing for Passive Income : ",
          description: "Earn by leasing NFTs while retaining ownership."
        },
        {
          title: "Customizable Leasing Terms : ",
          description: "Define leasing conditions like duration and rental fees."
        },
        {
          title: "Increased Accessibility : ",
          description: "Open NFTs to a wider audience, offering feature access without ownership."
        }
      ]
    },
    {
      title: "PHASE 7: GAMING AND ADDITIONAL UTILITIES",
      details: [
        "The final phase introduces gaming and extended utilities",
        {
          title: "Play-to-Earn Games : ",
          description: "Lia NFTs power blockchain games, offering in-game rewards."
        },
        {
          title: "AI-Powered Gaming Assistance : ",
          description: "Lia provides gaming insights and strategy optimization."
        },
        {
          title: "Cross-Platform Compatibility : ",
          description: "Lia NFTs integrate with other platforms and games."
        },
        {
          title: "DeFi Integration : ",
          description: "Access liquidity pools, lending, and yield farming within Lia Lab."
        }
      ]
    },
    {
      title: "Conclusion",
      details: [
        {
          description: "Lia Lab is a forward-thinking platform on the Abstract blockchain, merging AI, blockchain, and 3D animated art into an evolving ecosystem. With Lia at its core, the community gains tools to engage, earn, and shape the future of NFTs. Lia Lab is dedicated to innovation and inclusivity, paving the way for new Web3 possibilities."
        }
      ]
    }
  ];

  return (
    <>
      <Helmet>
        <title>Lia | Roadmap</title>
        <link rel="canonical" href="https://www.tilitnft.com/roadmap" />
        <meta name="description" content="The Roadmap Of Lialab NFT Project" />
      </Helmet>
      <div className="roadmap-container">
        <div className="roadmap-header">
          <h1 className="roadmap-title">
            <span className="roadmap-title-span">Lia Lab</span> Roadmap (Abstract Blockchain)
          </h1>
        </div>
        <div>
        <img className="rdmimage" src={banner} alt="Hero Banner" />
        </div>
        <div className="roadmap-content">
          <div className="roadmap-phases">
            {phases.map((phase, index) => (
              <div key={index} className="roadmap-phase">
                <div className="phase-header">
                  <h1 className="phase-title">{phase.title}</h1>
                </div>
                <div className="phase-details">
                  {phase.details.map((detail, detailIndex) => (
                    <React.Fragment key={detailIndex}>
                      {typeof detail === "string" ? (
                        <h2 className="phase-subtitle" dangerouslySetInnerHTML={{ __html: detail }} />
                      ) : (
                        <div>
                          <ul className="phase-list">
                            <li>
                              <span className="phase-item-title">{detail.title}</span>
                              <span dangerouslySetInnerHTML={{ __html: detail.description }} />
                            </li>
                          </ul>
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(Roadmap);